import SubmittedMessage from "./SubmittedMessage"

import styles from "../RereservationCompletePageV2.module.scss"

type Props = {
	email: string
	setEmail: (email: string) => void
	isEmailSubmitted: boolean
	isSubmittingEmail: boolean
	handleEmailSubmit: (e: React.FormEvent) => void
	// GIFT_CANDIDATE (予算ありギフト) のとき true。GIFT と同じ文面に
	// 「予算に達し次第終了」の 1 行だけ足す (biz 指示 2026-11-03)
	showsBudgetNote: boolean
}

// GIFT 完了画面用メール登録セクション。GIFT_CANDIDATE (予算ありギフト) も同じ見た目で出す
// design 参照: frontend/design/public/rereservation.pen Frame NbrnT 内 "Gift Campaign Email Section" (id: lgAAC)
const GiftEmailSection = ({
	email,
	setEmail,
	isEmailSubmitted,
	isSubmittingEmail,
	handleEmailSubmit,
	showsBudgetNote,
}: Props) => {
	let footer: JSX.Element
	if (isEmailSubmitted) {
		footer = <SubmittedMessage />
	} else {
		footer = (
			<div className={styles.gift_note}>
				<p>※ ポイントに関するお問い合わせは店舗ではなく</p>
				<p>point-campaign@souhl.co.jp にご連絡ください</p>
			</div>
		)
	}

	let submitLabel: string
	if (isSubmittingEmail) {
		submitLabel = "送信中..."
	} else {
		submitLabel = "登録"
	}

	return (
		<div
			className={`${styles.email_reminder_section} ${styles.email_reminder_section_gift}`}
		>
			<div className={styles.gift_badge_row}>
				<span className={styles.gift_badge}>🎁 ギフトキャンペーン</span>
			</div>
			<h3 className={styles.title_gift}>⚠️【必須】メールアドレスのご登録</h3>
			<div className={styles.gift_warning_box}>
				<p>ご登録いただけない場合、ポイントをお受け取りいただけません。</p>
				<p>
					一度キャンセルされると、ポイントは無効となりますのでご注意ください。
				</p>
				<p>ご来店確認後30日ほどで送付いたします。</p>
				{showsBudgetNote && <p>予算に達し次第終了となります。</p>}
			</div>
			<form onSubmit={handleEmailSubmit} className={styles.email_form}>
				<div className={styles.email_input_wrapper}>
					<input
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="example@email.com"
						className={`${styles.email_input} ${styles.email_input_gift}`}
						disabled={isSubmittingEmail}
					/>
					<button
						type="submit"
						className={styles.email_submit_button}
						disabled={isSubmittingEmail || !email}
					>
						{submitLabel}
					</button>
				</div>
				{footer}
			</form>
		</div>
	)
}

export default GiftEmailSection
